export const FETCH_PLANS_INITIATED = 'FETCH_PLANS_INITIATED'
export const FETCH_PLANS_SUCCESS = 'FETCH_PLANS_SUCCESS'
export const FETCH_PLANS_FAILED = 'FETCH_PLANS_FAILED'

export const PLAN_SELECTED = 'PLAN_SELECTED'
